<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{trailsNum}}" [matBadgeHidden]="trailsNum === 0" matBadgeOverlap="false" class="tab_trail_badge">Vessel's Trials</span>
        </ng-template>
        <dpi-trail-list (listSizeChanged)="setTrailsNum($event)" ></dpi-trail-list>
    </mat-tab>

    <mat-tab label="Details">
        <dpi-vessel-details></dpi-vessel-details>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{photosNum}}" [matBadgeHidden]="photosNum === 0" matBadgeOverlap="false" class="tab_vessel_badge">Photos</span>
        </ng-template>
        <dpi-vessel-photos (listSizeChanged)="setPhotosNum($event)"></dpi-vessel-photos>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{machineriesNum}}" [matBadgeHidden]="machineriesNum === 0" matBadgeOverlap="false" class="tab_vessel_badge">
                Thruster / Machinery
            </span>
        </ng-template>
        <dpi-vessel-machinery-list (listSizeChanged)="setMachineriesNum($event)"></dpi-vessel-machinery-list>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{dpControlNum}}" [matBadgeHidden]="dpControlNum === 0" matBadgeOverlap="false" class="tab_vessel_badge">DP Controls</span>
        </ng-template>
        <dpi-vessel-dp-control-list (listSizeChanged)="setDpControlNum($event)"></dpi-vessel-dp-control-list>
    </mat-tab>

    <mat-tab label="Redundancy">
        <ng-template mat-tab-label>
            <span matBadge="{{redundancyGroupNum + wcfdiNum + redundancyDiagramNum}}" 
            [matBadgeHidden]="redundancyGroupNum + wcfdiNum + redundancyDiagramNum === 0" matBadgeOverlap="false" class="tab_vessel_badge">
                Redundancy
            </span>
        </ng-template>

        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{redundancyGroupNum}}" [matBadgeHidden]="redundancyGroupNum === 0" matBadgeOverlap="false" class="tab_vessel_badge">
                        Redundancy Group
                    </span>
                </ng-template>
                <dpi-vessel-redundancy-group-list (listSizeChanged)="setRedundancyGroupNum($event)"></dpi-vessel-redundancy-group-list>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <span matBadge="{{wcfdiNum}}" [matBadgeHidden]="wcfdiNum === 0" matBadgeOverlap="false" class="tab_vessel_badge" 
                    matTooltip="Worst Case Failure Design Intent">WCFDI</span>
                </ng-template>
                <dpi-vessel-redundancy-wcfdi-list (listSizeChanged)="setWcfdiNumNum($event)"></dpi-vessel-redundancy-wcfdi-list>
            </mat-tab>

            <mat-tab label="Diagram">
                <ng-template mat-tab-label>
                    <span matBadge="{{redundancyDiagramNum}}" [matBadgeHidden]="redundancyDiagramNum === 0" matBadgeOverlap="false" class="tab_vessel_badge">Diagram</span>
                </ng-template>
                <dpi-vessel-redundancy-diagram-list (listSizeChanged)="setRedundancyDiagramNum($event)"></dpi-vessel-redundancy-diagram-list>
            </mat-tab>

        </mat-tab-group>
    </mat-tab>

</mat-tab-group>